<!-- 虚拟表格组件 -->
<template>
    <div class="evirt-table-content">
      <div id="e-virt-table" ref="e-virt-table">
          <div ref="overlayerRef" >
            <template >
              <div
                  :class="wrapper.class"
                  v-for="wrapper in overlayerView.views"
                  :style="wrapper.style"
                  :key="wrapper.type"
                  :id="'id-'+wrapper.type"
              >
                  <div  :style="view.style" v-for="view in wrapper.views" :key="view.key">
                      <div
                            class="cell"
                            v-for="cell in view.cells"
                            :key="`${cell.rowKey}_${cell.key}`"
                            :style="cell.style"
                            :title="'ssss'"
                        >
                            <CellSlot v-if="isFunction(cell.render)" :cell="cell"></CellSlot>
                            <slot v-if="isString(cell.render)" :name="cell.render" v-bind="cell" :cell="cell">  </slot>
                        </div>
                  </div>
                </div>
            </template>
          </div>
  
          <div id="e-virt-table-empty" ref="emptyElement">
              <p v-if="!hasTableEmptySlot">暂无数据</p>
              <slot name="tableEmpty" >  </slot>
          </div>
  
      </div>
      <div >
        <!-- <a @click="reLoadDataEvent">加载树形结构数据</a> -->
      </div>
    </div>
  </template>
  
  <script>
  import EVirtTable from "fy-virt-table";
  import CellSlot from "./CellSlot.js";
  import IS from './../utils/is.js';
  
  export default {
    // import引入的组件需要注入到对象中才能使用
    name: 'ETTable',
    components: {CellSlot},
    props: {
      isTree: { type: Boolean, default: false },
      // 是否启用懒加载（树形结构数据时有用）
      isLazyNode:{type:Boolean, default: false},
      // 懒加载使用的方法 (params):Promise=>{}  返回Promise对象， 参数 params= {colIndex,column,row,rowIndex,value}
      lazyFun:{type:Function},
      isCheck: { type: Boolean, default: false },
      // 表格配置数据
      tableConfig:{type:Object, default: () => ({})},
      column:{type:Array, default: () => []},
      tableData:{type:Array, default: () => []},
      // 表格事件 (type,...args)=>{}  type的值有：cellClick,selectionChange,dblclick
      event:{type:Function, default:null},
      // 设置默认选中行 [row,row,row]
      setCheckboxDefaultRows:{type:Array, default: () => []},
      // 设置checkbox是否可用  ({row,rowIndex})=>{return true/false} 返回true表示可用，false表示不可用
      getCheckboxDisabled:{type:Function},
    },
    data() {
      // 这里存放数据
      return {
        overlayerView: {
            views: [],
        },
        grid: null,
        baseColumnList: [],
        currentColumnList: [],
        cellValObj:{},
        internalConfig: {
            WIDTH: 100,
            HEADER_HEIGHT:54, // 表头高度
            MAX_HEIGHT: 580, // table 的最大高度
            BORDER_RADIUS:1, // 区域边框圆角
            ENABLE_SELECTOR: false, // 启用选择器
            ENABLE_AUTOFILL: false, // 启用填充
            EDIT_BG_COLOR:'#ffffff', //  可编辑背景色
            HEADER_BG_COLOR:'#fafafa', // 表头背景色  //#e6f7ff
            HIGHLIGHT_HOVER_ROW_COLOR:'#e6f7ff', // hover 高亮当前行颜色
            CHECKBOX_SIZE: 24, // 选择框的大小
            CELL_HEIGHT: 50, // 行高
            HIGHLIGHT_HOVER_ROW: true, // hover 高亮当前行
            HIGHLIGHT_SELECTED_ROW: false, // 高亮选中当前行
            ENABLE_RESIZE_ROW: false, // 启用调整行高
            FOOTER_FIXED: false,  // 合计底部固定
            SELECTOR_AREA_MIN_X: 4, // 设置选择器最小范围
            EMPTY_BODY_HEIGHT: 300, // 数据为空时表格体的高度
            DISABLED:true, // 禁止编辑
            ENABLE_CONTEXT_MENU: false, // 启用右键
        },
      };
    },
    // 监听属性 类似于data概念
    computed: {
      hasTableEmptySlot() {
        return !!this.$slots.tableEmpty;
      }
    },
    // 监控data中的数据变化
    watch: {
      setCheckboxDefaultRows:{
        handler(newRows){
          if(this.grid && !IS.isNullOrUnDef(newRows) && !IS.isEmpty(newRows)){
            this.$nextTick(()=>{
              this.setSelectionData(newRows);
            });
          }
        },
        deep: true,
      },
      column:{
        handler(newColumn){
          if(!IS.isNullOrUnDef(newColumn) && !IS.isEmpty(newColumn)){
            this.baseColumnList = newColumn.map(item=>({...item, readonly: true}));
          } else {
             this.baseColumnList = [];
          }
          this.updateCurrentColumnList();
        },
        deep: true,
        immediate: true,
      },
      tableData:{
        handler(newDataSource){
          if(this.grid) {
             let tempTable = [];
            if(!IS.isNullOrUnDef(newDataSource) && !IS.isEmpty(newDataSource)){
              tempTable = newDataSource;
            }
            this.updateTableData(tempTable);
          }
        },
        deep: true,
        immediate: true,
      },
      tableConfig:{
        handler(newConfig){
           this.internalConfig = Object.assign({},this.internalConfig,newConfig);
          if(this.grid) {
             this.updateConfig(this.internalConfig);
          }
        },
        deep: true,
        immediate: true,
      },
      isTree:{
        handler(){
          this.updateCurrentColumnList();
        },
      },
      isCheck:{
        handler(){
          this.updateCurrentColumnList();
        },
      },
      isLazyNode:{
        handler(){
          this.updateLazyLoadConfig();
        },
        immediate: true,
      },
       lazyFun:{
        handler(){
           this.updateLazyLoadConfig();
        },
      }
    },
    created() {},
    mounted() {
      this.updateCurrentColumnList();
      this.initGrid();

      if(!IS.isNullOrUnDef(this.setCheckboxDefaultRows) && !IS.isEmpty(this.setCheckboxDefaultRows)){
        this.$nextTick(()=>{
           this.setSelectionData(this.setCheckboxDefaultRows);
        });
      }
    },
    // 方法集合
    methods: {
      updateCurrentColumnList(){
         let columns = [...this.baseColumnList];

         if(this.isTree) {
            columns = this.applyTreeConfig(columns);
         }

         if(this.isCheck) {
            columns = this.applySelectionColumn(columns);
         }

         this.currentColumnList = columns;
         this.grid && this.grid.loadColumns(this.currentColumnList);
      },

      applyTreeConfig(columns){
        const res = [...columns];
        if (res.length === 0) {
           console.error('Table columns cannot be empty when isTree is true!');
           return res;
        }
        if (res[0].type !== 'tree') {
           res[0] = {...res[0], type: 'tree'};
        }
        return res;
      },

      applySelectionColumn(columns) {
         if (columns.some(col => col.type === 'selection' && col.key === 'selection')) {
            return columns;
         }
          const selectionColumn = {
              type: 'selection',
              key: 'selection',
              width: 10,
              readonly: true,
          };
          const updatedColumns = [...columns];
          updatedColumns.unshift(selectionColumn);
         return updatedColumns;
      },

      updateConfig(config){
        this.grid.loadConfig(config);
      },

      updateTableData(data){
        this.grid.loadData(data);
      },

      updateLazyLoadConfig() {
         if (this.isLazyNode && IS.isFunction(this.lazyFun)) {
            this.internalConfig = Object.assign({}, this.internalConfig, {
                EXPAND_LAZY: true,
                EXPAND_LAZY_METHOD: (params) => {
                    return this.lazyFun(params);
                }
            });
            if(this.grid) {
                 this.updateConfig(this.internalConfig);
            }
         } else {
             if (this.isLazyNode && !IS.isFunction(this.lazyFun)) {
                 console.warn('当 isLazyNode 启动时，lazyFun 必须是一个函数！');
             }
             this.internalConfig = Object.assign({}, this.internalConfig, {
                EXPAND_LAZY: false,
                EXPAND_LAZY_METHOD: null
            });
            if(this.grid) {
                 this.updateConfig(this.internalConfig);
            }
         }
      },

      initGrid(){
        const target = this.$refs['e-virt-table'];

        const selectableMethod = IS.isFunction(this.getCheckboxDisabled)
            ? (data) => this.getCheckboxDisabled(data)
            : () => true;

        this.internalConfig = Object.assign({}, this.internalConfig, {
           SELECTABLE_METHOD: selectableMethod
        });

        this.updateLazyLoadConfig();

        this.grid = new EVirtTable(target, {
            data: this.tableData,
            overlayerElement: this.$refs.overlayerRef,
            emptyElement: this.$refs.emptyElement,
            columns: this.currentColumnList,
            config: this.internalConfig,
        });

        this.grid.on("overlayerChange", (overlayer) => {
          this.overlayerView = overlayer;
        });

        this.grid.on("cellClick", (...args) => {
          this.cellValObj= { value: args[0].value, key: args[0].key, row: args[0].row, rowIndex: args[0].rowIndex, colIndex: args[0].colIndex };
          this.event && this.event('cellClick', ...args);
        });

        this.grid.on("dblclick", () => {
           this.event && this.event('dblclick', this.cellValObj);
          this.cellValObj = {};
        });

        this.isCheck === true && this.grid.on("selectionChange", (rows) => {
          this.event && this.event('selectionChange', rows);
        });
      },

      setSelectionData(rows,selected=true){
        if(this.grid){
          this.grid.setSelectionByRows(rows,selected);
        }
      },

      isFunction(val) {
        return IS.isFunction(val);
      },
      isString(val) {
        return IS.isString(val);
      },
    },
    beforeDestroy() {
       if (this.grid) {
          this.grid.destroy();
          this.grid = null;
       }
    }
  }
  </script>
  <style lang='less'>
  .cell{
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .e-virt-table-stage{
    border-radius: 4px;
  }
  </style>